import { atom } from "jotai";

import { VerificationModalStepStateAtom } from "./stores";

//This is reused for phone and email code steps
export const verificationCodeStepDataAtom = atom((get) => {
  const state = get(VerificationModalStepStateAtom);
  if (state.step === "VerifyCode") {
    return state;
  }
  return null;
});
